import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck, Star, Trophy } from "lucide-react";
import AnimatedSection from "./AnimatedSection";
import { technicalLeadData } from "./data";

const TechnicalLeadSpotlight = () => {
    return (
        <section className="relative py-10">

            <div className="absolute inset-0">
                {[...Array(30)].map((_, i) => (
                    <motion.div
                        key={i}
                        animate={{
                            y: [0, -100, 0],
                            x: [0, Math.sin(i) * 50, 0],
                            opacity: [0.1, 0.3, 0.1],
                        }}
                        transition={{
                            duration: 10 + i,
                            repeat: Infinity,
                            delay: i * 0.5,
                            ease: "linear"
                        }}
                        className="absolute w-32 h-32 rounded-full blur-xl bg-gradient-to-r from-purple-500/5 to-pink-500/5"
                        style={{
                            left: `${Math.random() * 100}%`,
                            top: `${Math.random() * 100}%`,
                        }}
                    />
                ))}
            </div>

            <div className="relative z-10 max-w-4xl mx-auto px-4">

                <AnimatedSection delay={0.2}>


                    <motion.div whileHover={{ scale: 1.01 }} className="relative group">
                        <div className="absolute -inset-8 bg-gradient-to-r from-purple-500/10 via-pink-500/10 to-purple-500/10 rounded-xl blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

                        <div className="relative bg-gray-900/50 backdrop-blur-xl rounded-xl border border-gray-700 shadow-2xl overflow-hidden">

                            <div className="flex flex-col lg:flex-row-reverse items-center gap-8">

                                <div className="relative p-8 lg:p-16 lg:w-2/5">
                                    <motion.div
                                        animate={{
                                            scale: [1, 1.05, 1],
                                            opacity: [0.3, 0.5, 0.3],
                                        }}
                                        transition={{
                                            duration: 4,
                                            repeat: Infinity,
                                            ease: "easeInOut"
                                        }}
                                        className="absolute -inset-2 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full blur-3xl"
                                    />

                                    <div className="relative w-full aspect-[4/5] max-w-[300px] mx-auto rounded-xl overflow-hidden border-4 border-gray-800 shadow-2xl">
                                        <img
                                            src={technicalLeadData.photo}
                                            alt={`${technicalLeadData.name} - ${technicalLeadData.role}`}
                                            loading="lazy"
                                            className="w-full h-full object-cover"
                                            style={{ objectPosition: 'center top' }}
                                        />
                                    </div>

                                    {/* <div className="absolute top-8 left-8 w-20 h-20 border-4 border-purple-500/30 rounded-full" />
                                    <div className="absolute bottom-8 right-8 w-16 h-16 border-4 border-pink-500/30 rounded-full" /> */}
                                </div>

                                <div className="p-8 lg:p-16 lg:w-3/5">
                                    <div className="inline-flex items-center gap-3 mb-6 px-5 py-2.5 rounded-full bg-gradient-to-r from-purple-500/20 to-pink-500/20 border border-purple-500/30">
                                        <ShieldCheck className="w-5 h-5 text-purple-400" />
                                        <span className="text-purple-300 font-semibold tracking-wide">RESPONSABLE TECHNIQUE</span>
                                    </div>

                                    <h3 className="text-4xl md:text-5xl font-bold text-white mb-3">
                                        {technicalLeadData.name}
                                    </h3>

                                    <div className="flex flex-wrap items-center gap-4 mb-6">
                                        <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-gray-800/50">
                                            <ShieldCheck className="w-4 h-4 text-purple-400" />
                                            <span className="text-gray-300 text-sm font-medium">{technicalLeadData.expertise}</span>
                                        </div>
                                        <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-gray-800/50">
                                            <Star className="w-4 h-4 text-amber-400" />
                                            <span className="text-gray-300 text-sm font-medium">{technicalLeadData.experience}</span>
                                        </div>
                                    </div>

                                    <p className="text-lg text-gray-300 mb-8 leading-relaxed">
                                        {technicalLeadData.description}
                                    </p>

                                    {/* <div className="grid grid-cols-2 gap-4">
                                        <div className="flex items-center gap-3 p-4 rounded-xl bg-gradient-to-r from-purple-500/10 to-pink-500/10 border border-purple-500/20">
                                            <ShieldCheck className="w-5 h-5 text-purple-400 shrink-0" />
                                            <div>
                                                <div className="text-2xl font-bold text-white">{technicalLeadData.projects}+</div>
                                                <div className="text-xs text-gray-400">Projets sécurisés</div>
                                            </div>
                                        </div>

                                        <div className="flex items-center gap-3 p-4 rounded-xl bg-gradient-to-r from-purple-500/10 to-pink-500/10 border border-purple-500/20">
                                            <Trophy className="w-5 h-5 text-amber-400 shrink-0" />
                                            <div>
                                                <div className="text-2xl font-bold text-white">CISSP</div>
                                                <div className="text-xs text-gray-400">Certifié</div>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </AnimatedSection>
            </div>
        </section>
    );
};

export default TechnicalLeadSpotlight;
